import React from "react";
import Badge from 'react-bootstrap/Badge';

import { FaWheelchair } from "react-icons/fa";
import { Colors } from '_styles';
import { PRMCodes } from '_utils/constants';

const AssistanceColumn = ({ values }) => {

    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            {
                values.assistances != null || values.assistances != undefined ?
                    <div style={{ display: 'flex', }}>
                        {[...new Set(values.assistances)].map((assistance, index) => {
                            if (PRMCodes.includes(assistance)) {
                                return (
                                    <div style={{ display: 'flex', marginLeft: index == 0 ? 0 : 5, justifyContent: 'left' }}>
                                        <Badge bg='primary' className='p-2' style={{ width: 50, height: 30 }}>{assistance}</Badge>
                                    </div>
                                );
                            }
                        })}
                    </div>
                    :
                    <Badge bg='primary' className='p-2' style={{ width: 50, height: 30 }}>{assistance}</Badge>
            }
            {
                values.personalEquipment ?
                    <Badge bg='info' className='p-2' style={{ width: 50, height: 30, marginLeft: 5 }}>
                        <div style={{ display: 'flex' }}>
                            <p style={{ color: Colors.TEXT_COLOR }}>PE</p>
                            <FaWheelchair
                                size={10}
                                style={{}}
                                color='white'
                            />
                        </div>
                    </Badge>
                    :
                    ""
            }
        </div>
    );

}

export default AssistanceColumn;